import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useEffect,
  useRef
} from "react";
import {
  Drawer,
  Button,
  Steps,
  Form,
  Input,
  notification,
  Space,
  Select,
  Alert,
  Upload,
  Collapse,
  Checkbox,
  Divider,
  Popconfirm,
  Popover,
  Tooltip,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import AccountPayableAPI from "../../../../restAPI/AccountPayableAPI";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
const Context = React.createContext({
  name: "Default",
});

const { Panel } = Collapse;
const StepForm = forwardRef((props, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { Dragger } = Upload;
  const [classification, setclassification] = useState([]);
  const [currencyType, setcurrencyType] = useState([]); // for Load Currency Types
  const [taxType, setTaxType] = useState([]); // for Load Tax Types
  const [incoTerms, setIncoTerms] = useState([]); //for loading inco terms
  const { token } = useSelector(state => state.auth);
  //we need to create a dynamic object from this payload and add yo this when reciving API responce
  const [payload, setPayload] = useState([]);
  const formRefs = useRef({}); // Store references to all form instances
  const [commonForm] = Form.useForm(); // to store the common fields for the forms
  const [originalPayload, setOriginalPayload] = useState([]); // to keep the priginal responce to use in reset
  const [btnnotyfyVisible, setBtnNotyfyVisible] = useState(true); //visibility of notofy admin button
  const navigate = useNavigate(); // navigate to trading partner
  const [showSubmissionPopconfirm, setShowSubmissionPopconfirm] = useState(false);
  const [submissionCancelButtonDisabled, setSubmissionCancelButtonDisabled] = useState(false);
  const [classificationChanged, setClassificationChanged] = useState(false);
  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({


    openDrawer: (selectedList) => {

      Object.values(formRefs.current).forEach((formInstance) => {
        if (formInstance) {
          formInstance.resetFields();
        }
      })
      // Clear the previous payload immediately
      setPayload([]);
      setOriginalPayload([]);

      setVisible(true); // Open drawer
      LoadInvoiceDetails(selectedList);
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
    },
  }));
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };
  const { Option } = Select;
  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  useEffect(() => {
    //decode token
    if (token !== null) {
      //GetDocumentTypes();
      GetDocumentClassification();
      GetCurrancyTypes();
      GetTaxTypes();
      GetIncoTerms();
    }
  }, []);

  // Sync all form values with the external state
  useEffect(() => {
    if (payload.length > 0) {
      const formKeys = Object.keys(formRefs.current);
      formKeys.forEach((key) => {
        const form = formRefs.current[key];
        // Update all relevant fields in the form
        form.setFieldsValue({
          classificationCode: payload[key].classificationCode,
          fxCurrency: payload[key].fxCurrency,
          fxCurrencyAmount: payload[key].fxCurrencyAmount,
          taxType: payload[key].taxType,
          taxRate: payload[key].taxRate,
          referenceNumber: payload[key].referenceNumber,
          customerDeclaration: payload[key].customerDeclaration,
          k1Form: payload[key].k1Form,
          incoTerms: payload[key].incoTerms,
          incoTermsReference: payload[key].incoTermsReference,
          IsConsolidated: payload[key].IsConsolidated
          // Add other fields here if needed
        });
      });
    }
  }, [payload, formRefs]);

  const onClassificationChange = (value, InvoiceNo) => {
    setClassificationChanged(true);
    setPayload((prev) =>
      prev.map((item) =>
        item.invoiceNumber == InvoiceNo ? { ...item, ["classificationCode"]: value, ["IsConsolidated"]: value == "004" ? true : false } : item
      )
    );
  };

  const onSelectFieldChange = (invoiceNo, field, value) => {
    setPayload((prev) =>
      prev.map((item) =>
        item.invoiceNumber == invoiceNo ? { ...item, [field]: value } : item
      )
    );
  }

  // Handle form field changes
  const handleFieldChange = (invoiceNo, field, e) => {
    setPayload((prev) =>
      prev.map((item) =>
        item.invoiceNumber == invoiceNo ? { ...item, [field]: e.target.value } : item
      )
    );
  };

  const onSubmissionPopConfirm = () => {
    setShowSubmissionPopconfirm(true);
  }

  const handleAbortSubmissionConfirm = () => {
    setSubmissionCancelButtonDisabled(true)
    openNotificationWithIcon(
      "error",
      "Abort",
      `Invoice submission cancelled`,
      "bottomLeft"
    );

    setTimeout(() => {
      setShowSubmissionPopconfirm(false);
      setSubmissionCancelButtonDisabled(false);

    }, 3000);
  };

  // Function to handle the common submit button click
  const handleSubmit = async () => {
    try {
      setShowSubmissionPopconfirm(false);
      // Validate all forms
      const formKeys = Object.keys(formRefs.current);
      const results = await Promise.all(
        formKeys.map((key) => formRefs.current[key].validateFields())
      );

      // If all forms are valid, proceed with submission
      let companyId = localStorage.getItem("companyId") ?? "";
      let groupId = localStorage.getItem("groupId") ?? "";
      const rows = [];
      payload.map((rowValue) => {
        rows.push({
          MOGU_UUID: rowValue.MOGU_UUID,
          TPS_Id: rowValue.TPS_Id,
          transactionType: "Accounts payable",
          classificationChanged: classificationChanged,
          submitting_items: {
            invoiceNumber: rowValue.invoiceNumber,
            documentType: rowValue?.documentType?.code,
            classificationCode: rowValue?.classificationCode,
            fxCurrency: rowValue?.fxCurrency,
            fxCurrencyAmount: rowValue?.fxCurrencyAmount,
            taxType: rowValue?.taxType,
            taxRate: rowValue?.taxRate,
            ...(rowValue.customerDeclaration != null && rowValue.customerDeclaration.trim() !== "" && { kFormNumber: rowValue.customerDeclaration }),//K form number
            ...(rowValue.k1Form != null && rowValue.k1Form.trim() !== "" && { kFormType: rowValue.k1Form }),
            ...(rowValue.incoTerms != null && rowValue.incoTerms.trim() !== "" && { incoTerms: rowValue.incoTerms }),
            ...(rowValue.incoTermsReference != null && rowValue.incoTermsReference.trim() !== "" && { incoTermsReference: rowValue.incoTermsReference })
          },
          companyId: companyId,
          groupId: groupId

        });
      });
      await handleInvoiceSubmission(rows);
      
    } catch (errors) {
      // If any form is invalid, show error messages
      console.log('Validation errors:', errors);
    }
  };

  const GetDocumentClassification = async () => {
    await AccountPayableAPI.GetDocumentClassification(
      token,
      localStorage.getItem('groupId'),
      localStorage.getItem('companyId')
    )
      .then((res) => {
        if (res?.data) {
          const classification = res.data.map((rowValue) => ({
            value: rowValue.code,
            label: `${rowValue.code} - ${rowValue.description}`, // string for search
            code: rowValue.code,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
  
          const valuesToRemove = ['009', '033', '034', '035', '036', '037', '045'];
          const ARClassificationCodes = classification.filter(
            (item) => !valuesToRemove.includes(String(item.value))
          );
  
          setclassification(ARClassificationCodes);
        }
      })
      .catch((err) => {
        const message = err.response?.data?.message || err.message;
        openNotificationWithIcon('error', 'No Document Type found', message, 'bottomLeft');
      });
  };

  const GetCurrancyTypes = async () => {
    await AccountPayableAPI.GetCurrancyTypes(token)
      .then((res) => {
        if (res?.data) {
          const CurrancyTypes = res.data.map((rowValue) => ({
            value: rowValue.code,
            label: rowValue.currency
          })).sort((a, b) => a.label.localeCompare(b.label));
          setcurrencyType(CurrancyTypes);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Currancy Type found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Currancy Type found', `${err.message}`, 'bottomLeft');
        }
      });
  }

  const GetTaxTypes = async () => {
    await AccountPayableAPI.GetTaxTypes(token)
      .then((res) => {
        if (res?.data) {
          const taxTypes = res.data.map((rowValue) => ({
            value: rowValue.code,
            label: rowValue.description
          })).sort((a, b) => a.label.localeCompare(b.label));
          setTaxType(taxTypes);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Tax Type found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Tax Type found', `${err.message}`, 'bottomLeft');
        }
      });
  }

  const LoadInvoiceDetails = async (invoiceList) => {
    const formData = {
      invoiceNumbers: invoiceList, //["INV25-0210M"],
      transactionType: "Accounts payable",
      companyId: localStorage.getItem("companyId") //"6787e74b5035b0a86e7793c5"
    };
    await AccountPayableAPI.GetInvoiceDetails(token, localStorage.getItem("groupId"), localStorage.getItem("companyId"), formData)
      .then((res) => {
        if (res?.data) {
          // this will return duplicate data as well so we need to remove the duplicates
          const invoicDetails = removeDuplicates(res.data);
          const rows = [];
          invoicDetails.map((rowValue) => {
            rows.push(
              {
                invoiceNumber: rowValue.invoiceNumber,
                documentType: { "code": rowValue.documentType.code, "description": rowValue.documentType.description },
                classificationCode: rowValue.classificationCode,
                fxCurrency: rowValue.fxCurrency,
                fxCurrencyAmount: rowValue.fxCurrencyAmount,
                taxType: rowValue.taxType,
                taxRate: rowValue.taxRate,
                referenceNumber: "",
                customerDeclaration: "",
                k1Form: "",
                incoTerms: "",
                incoTermsReference: "",
                IsConsolidated: (rowValue.classificationCode == "004") ? true : false,
                MOGU_UUID: rowValue?.MOGU_UUID,
                TPS_Id: rowValue?.TPS_Id,
                isTradingPartnerValid: rowValue?.isTradingPartnerValid,
                isFailedInvoice: rowValue?.isFailedInvoice,
              }
            )
          });
          setPayload(rows);
          setOriginalPayload(rows);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Invoice Details found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Invoice Details found', `${err.message}`, 'bottomLeft');
        }
      });
  }

  const removeDuplicates = (arr) => {
    const seen = new Set(); // Track seen IDs
    return arr.filter((item) => {
      if (!seen.has(item.invoiceNumber)) {
        seen.add(item.invoiceNumber);
        return true;
      }
      return false; // Discard duplicates
    });
  };


  const GetIncoTerms = async () => {
    await AccountPayableAPI.GetIncoTerms(token)
      .then((res) => {
        if (res?.data) {
          const rows = [];
          res.data.sort((a, b) => a.code.localeCompare(b.code));
          res.data.map((rowValue) => {
            rows.push({
              value: rowValue.code,
              label: (
                <div
                  style={{
                    whiteSpace: 'normal',
                    lineHeight: '1.5em',
                    maxWidth: '100%',
                    overflowWrap: 'break-word',
                  }}
                >
                  <strong>{rowValue.code}</strong> - {rowValue.name}
                </div>

              )
            });
          });
          setIncoTerms(rows);
        }
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon('error', 'No Tax Type found', `${err.response.data.message}`, 'bottomLeft');
        } else {
          openNotificationWithIcon('error', 'No Tax Type found', `${err.message}`, 'bottomLeft');
        }
      });
  }

  const consolidatedChange = (e, invoiceNumber) => {
    setClassificationChanged(true);
    // Step 1: Find the index of the object to update
    let index = payload.findIndex(invoice => (invoice.invoiceNumber == invoiceNumber));
    // Step 2: Create a copy of the array
    const updateInvoices = [...payload];
    // Step 3: Update the specific object in the copied array
    updateInvoices[index] = { ...updateInvoices[index], IsConsolidated: e.target.checked };
    // Step 4: Set the new array as the updated state
    if (e.target.checked) {
      updateInvoices[index] = { ...updateInvoices[index], classificationCode: "004" };
      //change the drop down      
    }
    else {
      updateInvoices[index] = { ...updateInvoices[index], classificationCode: undefined };
    }
    setPayload(updateInvoices);
  }

  const validateField = ({ fieldName, maxLength = 250, regex, errorMessage = "" }) =>
    ({ getFieldValue }) => ({
      validator(_, value) {
        // Apply validation only if "classificationCode" is '034' and the field is empty
        if (getFieldValue("classificationCode") === "034" && !value) {
          return Promise.reject(new Error(`${fieldName} is required for Selected Classification`));
        }

        // Ensure the value does not match the forbidden regex pattern
        if (regex.test(value)) {
          return Promise.reject(new Error(`${fieldName}: ${errorMessage}`));
        }

        // Ensure the length does not exceed maxLength
        if (value && value.length > maxLength) {
          return Promise.reject(new Error(`${fieldName} cannot exceed ${maxLength} characters!`));
        }

        return Promise.resolve();
      },
    });
  //-------------------------------------------------------------------------Common Field Submission---------------------------------------------------------------------
  const handleInvoiceSubmission = async (requestData) => {

    await AccountPayableAPI.InvoiceSubmition(token, localStorage.getItem("groupId"), localStorage.getItem("companyId"), requestData)
      .then((response) => {
        openNotificationWithIcon("success", "Successful", `${response.message}`, "bottomLeft");
        //setVisible(false);
        drawerClose();
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon("error", "Invoice Submission failed", `${err.response.data.message}`, "bottomLeft");
        } else {
          openNotificationWithIcon("error", "Invoice Submission failed", `${err.message}`, "bottomLeft");
        }
      });
  }
  const onClassificationCommonChange = (value) => {
    setClassificationChanged(true);
    if (value === "004") {
      commonForm.setFieldsValue({ IsConsolidated: true });
    }
    else {
      commonForm.setFieldsValue({ IsConsolidated: false });
    }
  }
  const consolidatedCommonChange = (value) => {
    setClassificationChanged(true);
    if (value.target.checked) {
      commonForm.setFieldsValue({ classificationCode: "004" });
    }
    else {
      commonForm.setFieldsValue({ classificationCode: null });
    }
  }
  const onFinish = (values) => {
    // go thorug the eacj item in invoices states and set the fields
    let invoiceChangeList = payload.map((invoice) => {
      return {
        ...invoice,
        classificationCode: (values.classificationCode) ? values.classificationCode : invoice.classificationCode, //(!values?.classificationCode|| values?.classificationCode.trim() === "")?invoice.classificationCode:values.classificationCode,
        fxCurrency: (values.fxCurrency) ? values.fxCurrency : invoice.fxCurrency,
        IsConsolidated: (values.IsConsolidated) ? values.IsConsolidated : invoice.IsConsolidated,
        referenceNumber: (values.referenceNumber) ? values.referenceNumber : invoice.referenceNumber,
        fxCurrencyAmount: (values.fxCurrencyAmount) ? values.fxCurrencyAmount : invoice.fxCurrencyAmount,
        customerDeclaration: (values.customerDeclaration) ? values.customerDeclaration : invoice.customerDeclaration,
        k1Form: (values.k1Form) ? values.k1Form : invoice.k1Form,
        incoTerms: (values.incoTerms) ? values.incoTerms : invoice.incoTerms,
        incoTermsReference: (values.incoTermsReference) ? values.incoTermsReference : invoice.incoTermsReference
      }
    });
    setPayload(invoiceChangeList);
  }
  const onReset = () => {
    commonForm.resetFields();
  };


  const renderBulkSettingComponent = () => {
    return (
      <>
        {/* Classification Code */}
        <Form.Item
          label={
            <span>
              Update Classification Code{' '}
              <Popover content={popoverContentCC} title="Classification Info" trigger="hover">
                <InfoCircleOutlined className="info-icon" />
              </Popover>
            </span>
          }
          name="classificationCode"
        >
          <Select
            showSearch                                  // enable search
            size="large"
            options={classification}                    // label must be string
            onSelect={(value) => { onClassificationCommonChange(value) }}
            placeholder="Please Select Classification Code"
            optionFilterProp="label"                    // search uses label
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }                                           // case-insensitive search
            optionRender={(option) => (                 // optional: styled dropdown items
              <div style={{ whiteSpace: 'normal', lineHeight: '1.2em', overflowWrap: 'break-word' }}>
                {option.data.label}
              </div>
            )}
          />
        </Form.Item>
        <Form.Item label="" name="IsConsolidated" valuePropName="checked">
          <Checkbox onChange={consolidatedCommonChange} >Consolidated</Checkbox>
        </Form.Item>
        <Form.Item label="FX Currency" name="fxCurrency"
        >
          <Select size="large" options={currencyType} placeholder="Please Select">
          </Select>
        </Form.Item>

        {/* FX Currency Amount */}
        <Form.Item label="FX Currency Amount" name="fxCurrencyAmount" >
          
          <Input size="large" /*onChange={(e)=>handleFieldChange(invoice.invoiceNumber,"fxCurrencyAmount",e)}*/ />
        </Form.Item>

        {/* Customer Declaration */}
        <Form.Item label={
          <span>
            K Form Number
            {commonForm.getFieldValue('classificationCode') === '034' && (
              <span className="ant-form-item-required"> *</span>
            )}
          </span>
        }
          name="customerDeclaration"
          dependencies={["classificationCode"]}
          rules={[validateField({
            fieldName: "Declaration",
            maxLength: 250,
            regex: /^\d+(\s|\d)*$/,
            errorMessage: "Cannot contain only numbers!",
          }),]}>
          <Input size="large" placeholder="Please fill out if Applicable" />
        </Form.Item>

        {/* K1 Form */}
        <Form.Item label={
          <span>
            K Form Type
            {commonForm.getFieldValue('classificationCode') === '034' && (
              <span className="ant-form-item-required"> *</span>
            )}
          </span>
        }
          name="k1Form"
          dependencies={["classificationCode"]}
          rules={[validateField({
            fieldName: "K1 Form",
            maxLength: 50,
            regex: /^\d+(\s|\d)*$/,
            errorMessage: "Cannot contain only numbers!",
          }),]}>
          <Input size="large" placeholder="Please fill out if Applicable" />
        </Form.Item>

        {/* Inco Terms */}
        <Form.Item label={
          <span>
            Inco Terms
            {commonForm.getFieldValue('classificationCode') === '034' && (
              <span className="ant-form-item-required"> *</span>
            )}
          </span>
        }
          name="incoTerms"
          dependencies={["classificationCode"]}
          rules={[({ getFieldValue }) => ({
            validator(_, value) {
              // Apply validation only if "item1" is selected
              if (getFieldValue("classificationCode") === "034" && !value) {
                return Promise.reject(new Error(`Inco Terms is required for Selected Classification`));
              }
              return Promise.resolve();
            },
          }),]}>
          <Select size="large" options={incoTerms} placeholder="Please Select if Applicable"
            optionRender={(option) => (
              <div
                style={{
                  whiteSpace: 'normal',
                  lineHeight: '1.5em',
                  maxWidth: '100%',
                  overflowWrap: 'break-word',
                }}
              >
                {option.data.label}
              </div>
            )}>
          </Select>
        </Form.Item>

        {/* Inco Terms Ref */}
        <Form.Item label={
          <span>
            Inco Terms Ref
            {commonForm.getFieldValue('classificationCode') === '034' && (
              <span className="ant-form-item-required"> *</span>
            )}
          </span>
        }
          name="incoTermsReference"
          dependencies={["classificationCode"]}
          rules={[validateField({
            fieldName: "Inco Terms Ref",
            maxLength: 50,
            regex: /^\d+(\s|\d)*$/,
            errorMessage: "Cannot contain only numbers!",
          }),]}>
          <Input size="large" placeholder="Please fill out if Applicable" />
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Apply
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Space>
        </Form.Item>
      </>);
  }

  const handleReset = () => {
    let invoiceResetList = payload.map((invoice) => {
      let originalInvoce = originalPayload.filter((item) => { return item.invoiceNumber === invoice.invoiceNumber });
      return {
        ...invoice,
        classificationChanged: false,
        classificationCode: originalInvoce[0].classificationCode,
        fxCurrency: originalInvoce[0].fxCurrency,
        IsConsolidated: originalInvoce[0].IsConsolidated,
        referenceNumber: originalInvoce[0].referenceNumber,
        fxCurrencyAmount: originalInvoce[0].fxCurrencyAmount,
        taxType: originalInvoce[0].taxType,
        taxRate: originalInvoce[0].taxRate,
        referenceNumber: "",
        customerDeclaration: "",
        k1Form: "",
        incoTerms: "",
        incoTermsReference: ""
      }
    });
    setPayload(invoiceResetList);
  }

  const drawerClose = () => {
    setVisible(false);
    commonForm.resetFields();
  }
  //--------------------------------------------------------------------------End of Common Field Submission-------------------------------------------------------------         
  //-----------------------------------------------------------------------Popup Confirm error-----------------------------------------------------------------
  const handleConfirm = async () => {
    NotifyAdmin();
  };

  const handleCancel = () => {
  };

  const NotifyAdmin = async () => {

    //send email to the admin about the failed reasons responce : "message": "Notification sent to system admins with unique attachments."
    let notificationList = payload.reduce((acc, invoice) => {
      if (invoice.isFailedInvoice) {
        acc.push({
          moguUUID: invoice.MOGU_UUID,
          tpsID: invoice.TPS_Id,
          invoiceNumber: invoice.invoiceNumber,
          reason: "Data extraction encountered an issue. Please verify the document and reupload to proceed."
        });
      }
      return acc;
    }, []);
    const notifyadminpayload = {
      groupId: localStorage.getItem("groupId"),
      companyId: localStorage.getItem("companyId"),
      failedInvoices: notificationList
    };
    await AccountPayableAPI.NotifyErrorAdminViaEmail(token, localStorage.getItem("groupId"), localStorage.getItem("companyId"), notifyadminpayload)
      .then((response) => {
        openNotificationWithIcon("success", "Successful", `${response.message}`, "bottomLeft");
        setBtnNotyfyVisible(false);

      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon("error", "Notify Admin  failed", `${err.response.data.message}`, "bottomLeft");
        } else {
          openNotificationWithIcon("error", "Notify Admin  failed", `${err.message}`, "bottomLeft");
        }
      });
  }
  //------------------------------------------------------------------------End of popup confirm---------------------------------------------
  //-----------------------------------------------------------Trading Partner redirect----------------------------------------------------
  const redirectToTradingPartner = () => {
    navigate("/masterdata/tradingpartners");
  }
  //-----------------------------------------------------------End Trading partner redirect---------------------------------------------

  const popoverContentCC = (
    <div>
      For PDF submissions: The classification code is automatically set based on the trading<br />
      partner or company classification code selected during setup. If you need to use a different<br />
      code, update it here.<br /><br />
      For Excel submissions: Classification codes are taken from the Excel template. If you need <br />
      to use a different code, update it here. Updating the code here will override all line item <br />
      classification codes in the submission.
    </div>
  );
  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="e-Invoice Submission"
        width={700}
        visible={visible}
        onClose={drawerClose}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large" onClick={handleReset}>
              Reset
            </Button>

            <Tooltip
              title={
                payload.some(item => item.isTradingPartnerValid === false)
                  ? "Submission blocked: One or more invoices have an invalid trading partner."
                  : payload.every(item => item.isFailedInvoice)
                  ? "Submission blocked: All invoices failed. Please re-upload."
                  : ""
              }
            >
            <span>
              <Popconfirm
                title={`Please confirm the classification codes before submitting?`}
                open={showSubmissionPopconfirm}
                onConfirm={handleSubmit}
                onCancel={handleAbortSubmissionConfirm}
                okText="Confirm"
                cancelText="Cancel"
                cancelButtonProps={{ disabled: submissionCancelButtonDisabled }}
              >
                <Button
                  type="primary"
                  size="large"
                  onClick={onSubmissionPopConfirm}
                  disabled={(payload.every(item => item.isFailedInvoice)) || (payload.some(item => item.isTradingPartnerValid === false))}
                >
                  Submit
                </Button>
              </Popconfirm>
            </span>
            </Tooltip>
          </div>
        }
      >
        <div style={{ marginTop: 24 }}>
          {payload.length > 1 && (
            <>
              <Divider style={{ borderColor: '#7cb305' }}>Common Update Fields</Divider>
              <Form form={commonForm}  // Store form instance
                layout="vertical"
                style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}
                onFinish={onFinish}>
                {renderBulkSettingComponent()}
              </Form>
              <Divider style={{ borderColor: '#7cb305' }}></Divider>
            </>
          )}
          {payload.some(item => item.isFailedInvoice) && (
            <Alert
              message="Data Submission Error"
              type="error"
              description={
                <div>
                  Data extraction encountered an issue. Please verify the document and reupload to proceed.
                  <Popconfirm
                    title={`Do you want to send an email to the system admin?`}
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button Primary size="small" type="primary" style={{ marginTop: 8 }} disabled={!btnnotyfyVisible}>
                      Notify Admin
                    </Button>
                  </Popconfirm>
                </div>
              }
            />
          )}
          {//isSingleUpload ? renderSingleSubmitContent() : (
            <Collapse accordion
              activeKey={payload.length == 1 ? 0 : undefined} // Control expanded panels
              collapsible={!payload.length == 1} // Disable collapsible behavior if only one item
            >
              {payload.map((invoice, index) => (
                <Panel
                  header={`Invoice No: ${invoice.invoiceNumber}`}
                  key={index}
                >
                  <Form ref={(form) => (formRefs.current[index] = form)} // Store form instance
                    layout="vertical"
                    style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}
                    initialValues={{
                      invoiceNumber: invoice.invoiceNumber, documentType: invoice.documentType.description, classificationCode: invoice["classificationCode"] ?? "036",
                      IsConsolidated: invoice.IsConsolidated, referenceNumber: (invoice.documentType.description !== "Invoice") ? invoice.referenceNumber : "N/A",
                      fxCurrency: invoice["fxCurrency"] || undefined, taxType: invoice["taxType"] || undefined, fxCurrencyAmount: invoice["fxCurrencyAmount"]
                    }}
                  >
                    {(!invoice.isTradingPartnerValid) && (<Alert
                      message="Incomplete Trading Partner"
                      description="Master data incomplete for the selected Trading Partner. Please update details to proceed."
                      type="warning"
                      action={
                        <Button Primary size="small" type="primary" onClick={redirectToTradingPartner}>
                          Go to Trading Partners
                        </Button>
                      }
                    />
                    )}
                    {/* Invoice Number */}
                    <Form.Item label="Invoice Number" name="invoiceNumber">
                      <Input size="large" defaultValue="123234" disabled />
                    </Form.Item>

                    {/* Document Type */}
                    <Form.Item label="Document Type" name="documentType">
                      <Input size="large" defaultValue="Invoice" disabled />
                    </Form.Item>

                    {/* Classification Code */}
                    <Form.Item
                      label={
                        <span>
                          Update Classification Code{' '}
                          <Popover content={popoverContentCC} title="Classification Info" trigger="hover">
                            <InfoCircleOutlined className="info-icon" />
                          </Popover>
                        </span>
                      }
                      name="classificationCode"
                      rules={[{ required: true, message: "Classification Required" }]}
                      required>
                      <Select 
                        size="large" 
                        showSearch
                        options={classification} 
                        onChange={(value) => { onClassificationChange(value, invoice.invoiceNumber) }} 
                        placeholder="Please Select"
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        optionRender={(option) => (
                          <div style={{ whiteSpace: 'normal', lineHeight: '1.2em', overflowWrap: 'break-word' }}>
                            {option.data.label}
                          </div>
                        )}
                      >
                      </Select>
                    </Form.Item>
                    <Form.Item label="" name="IsConsolidated" valuePropName="checked">
                      <Checkbox onChange={(e) => { consolidatedChange(e, invoice.invoiceNumber) }} >Consolidated</Checkbox>
                    </Form.Item>
                    {/* FX Currency */}
                    <Form.Item label="FX Currency" name="fxCurrency"
                      rules={[{ required: true, message: "FX Currency Required" }]}
                      required>
                      <Select size="large" options={currencyType} onSelect={(value, option) => onSelectFieldChange(invoice.invoiceNumber, "fxCurrency", value)} placeholder="Please Select">
                      </Select>
                    </Form.Item>

                    {/* FX Currency Amount */}
                    <Form.Item label="FX Currency Amount" name="fxCurrencyAmount"
                      rules={[{ required: true, message: "Currrency Amount Required" }]} required >
                      <Input size="large" onChange={(e) => handleFieldChange(invoice.invoiceNumber, "fxCurrencyAmount", e)} />
                    </Form.Item>

                    {/* Customer Declaration */}
                    <Form.Item label="K Form Number"
                      name="customerDeclaration"
                      dependencies={["classificationCode"]}
                      rules={[validateField({
                        fieldName: "Declaration",
                        maxLength: 250,
                        regex: /^\d+(\s|\d)*$/,
                        errorMessage: "Cannot contain only numbers!",
                      }),]} required={invoice["classificationCode"] === "034"}>
                      <Input size="large" placeholder="Please fill out if Applicable" onChange={(e) => handleFieldChange(invoice.invoiceNumber, "customerDeclaration", e)} />
                    </Form.Item>

                    {/* K1 Form */}
                    <Form.Item label="K Form Type"
                      name="k1Form"
                      dependencies={["classificationCode"]}
                      rules={[validateField({
                        fieldName: "K1 Form",
                        maxLength: 50,
                        regex: /^\d+(\s|\d)*$/,
                        errorMessage: "Cannot contain only numbers!",
                      }),]} required={invoice["classificationCode"] === "034"}>
                      <Input size="large" placeholder="Please fill out if Applicable" onChange={(e) => handleFieldChange(invoice.invoiceNumber, "k1Form", e)} />
                    </Form.Item>

                    {/* Inco Terms */}
                    <Form.Item label="Inco Terms"
                      name="incoTerms"
                      dependencies={["classificationCode"]}
                      rules={[({ getFieldValue }) => ({
                        validator(_, value) {
                          // Apply validation only if "item1" is selected
                          if (getFieldValue("classificationCode") === "034" && !value) {
                            return Promise.reject(new Error(`Inco Terms is required for Selected Classification`));
                          }
                          return Promise.resolve();
                        },
                      }),]}>
                      <Select size="large" options={incoTerms} placeholder="Please Select if Applicable" onSelect={(value, option) => onSelectFieldChange(invoice.invoiceNumber, "incoTerms", value)}
                        optionRender={(option) => (
                          <div
                            style={{
                              whiteSpace: 'normal',
                              lineHeight: '1.5em',
                              maxWidth: '100%',
                              overflowWrap: 'break-word',
                            }}
                          >
                            {option.data.label}
                          </div>
                        )}>
                      </Select>
                    </Form.Item>

                    {/* Inco Terms Ref */}
                    <Form.Item label="Inco Terms Ref"
                      name="incoTermsReference"
                      dependencies={["classificationCode"]}
                      rules={[validateField({
                        fieldName: "Inco Terms Ref",
                        maxLength: 50,
                        regex: /^\d+(\s|\d)*$/,
                        errorMessage: "Cannot contain only numbers!",
                      }),]} required={invoice["classificationCode"] === "034"}>
                      <Input size="large" placeholder="Please fill out if Applicable" onChange={(e) => handleFieldChange(invoice.invoiceNumber, "incoTermsReference", e)} />
                    </Form.Item>
                  </Form>
                </Panel>
              ))}
            </Collapse>
            // )
          }
        </div>
      </Drawer>
    </Context.Provider>
  );
});
export default StepForm;
